module.exports = __webpack_public_path__ + "img/proses_rtc.ed2ab58b.svg";